import { ModelRepository } from 'b302-frontend-library';
import ResponseAnswer from '../models/ResponseAnswer';

class ResponseAnswerRepository extends ModelRepository<ResponseAnswer> {

    public constructor(response: number) {
        super(`/responses/${response}/answers`);
    }

}

export default ResponseAnswerRepository;
